import { render } from "./DetalleCredencial.vue?vue&type=template&id=2a986486&scoped=true"
import script from "./DetalleCredencial.vue?vue&type=script&lang=js"
export * from "./DetalleCredencial.vue?vue&type=script&lang=js"

import "./DetalleCredencial.vue?vue&type=style&index=0&id=2a986486&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a986486"]])

export default __exports__